import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Importar el router
import "./helpers/providers/AxiosRequestInterceptor.js";
import Notiflix from "notiflix";
import Aura from "@primevue/themes/aura";
import PrimeVue from "primevue/config";

import "./registerServiceWorker";

import "./index.css";

console.log(process.env.VUE_APP_API_URL);

const app = createApp(App);
app.use(PrimeVue, { theme: { preset: Aura } });

document.documentElement.classList.add("dark");

app.use(router); // Usar el router
app.mount("#app");
app.config.globalProperties.$notiflix = Notiflix;

app.config.globalProperties.$notiflix.Loading.init({
  //backgroundColor: 'rgba(0,0,0,0.9)',
  //svgColor: '#fff',
  svgSize: "100px",
  svgColor: "#f97316",
  clickToClose: false,
});

document.body.classList.remove("overflow-hidden");
